import React from 'react';
import { getHighlightedParts } from './utils';

interface HighlightedTextProps {
  text: string;
  keyword: string;
}

/**
 * Component that highlights matching keywords in text
 */
export const HighlightedText: React.FC<HighlightedTextProps> = ({ text, keyword }) => {
  const parts = getHighlightedParts(text, keyword);

  return (
    <>
      {parts.map((part, idx) => {
        // Create unique key using part content and position to avoid ESLint warning
        const uniqueKey = `${part.isHighlighted ? 'h' : 't'}-${idx}-${part.text.length}`;

        return part.isHighlighted ? (
          <span key={uniqueKey} className='bg-[#FFFEC8] font-medium'>
            {part.text}
          </span>
        ) : (
          <React.Fragment key={uniqueKey}>{part.text}</React.Fragment>
        );
      })}
    </>
  );
};
